// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"m4-z","dimensionLabel":"n4-z","styleChooserControlWrapper":"o4-z","styleChooserControl":"p4-z","disabled":"q4-z","giftCard":"r4-z","styleChooserText":"s4-z"};